import { createBrowserRouter } from "react-router-dom";
import routes from "./components/pages";

const Router = (lang?: string) => {
  return createBrowserRouter([...routes(lang)]);
};

export default Router;
